import * as React from 'react';
export const iosShareSvg = React.forwardRef(function iosShareSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.75 4.55a.7.7 0 0 1 0 1.4H3a.05.05 0 0 0-.05.05v4.5c0 .028.022.05.05.05h6a.05.05 0 0 0 .05-.05V6A.05.05 0 0 0 9 5.95h-.75a.7.7 0 0 1 0-1.4H9c.8 0 1.45.65 1.45 1.45v4.5c0 .801-.65 1.45-1.45 1.45H3c-.8 0-1.45-.649-1.45-1.45V6c0-.8.65-1.45 1.45-1.45h.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.634.103a.702.702 0 0 1 .84.081l2.181 2a.7.7 0 0 1-.946 1.031L6.7 2.291v5.585a.7.7 0 0 1-1.4 0V2.29l-1.009.924a.7.7 0 1 1-.945-1.03l2.181-2 .107-.082Z',
    }),
  );
});
iosShareSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var iosShare = {
  category: 'icon',
  colorable: true,
  name: 'iosShare',
  svg: iosShareSvg,
};
